import { createLucideIcon } from "lucide-react";

export const MoreVertical = createLucideIcon(
    "MoreVertical",
    [
        [
            "path",
            {
                d: "M11.9842 18H11.9932",
                key: "1t3i4x",
            },
        ],
        [
            "path",
            {
                d: "M11.992 12H12.001",
                key: "wck4os",
            },
        ],
        [
            "path",
            {
                d: "M11.9998 6H12.0088",
                key: "jsy5t7",
            },
        ],
    ],
);
